import React, { useState, useEffect } from 'react';
import { Property } from "@/types/property";
import { PropertyCard } from "./PropertyCard";
import { Button } from "./ui/button";
import { Link } from "react-router-dom";
import { ArrowRight, Building2 } from "lucide-react";
import axiosInstance from '../config/axios';

export function PropertiesPreview() {
  const [properties, setProperties] = useState<Property[]>([]);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchFeatured = async () => {
      try {
        const response = await axiosInstance.get('/api/properties');
        const propertiesData = response.data.properties || [];
        
        setProperties((Array.isArray(propertiesData) ? propertiesData : []).slice(0, 3));
      } catch (error) {
        console.error('Error fetching properties preview:', error);
      } finally {
        setIsLoading(false);
      }
    };
    fetchFeatured();
  }, []);

  if (isLoading) return (
    <div className="py-24 container mx-auto px-4">
      <div className="animate-pulse flex space-x-4">
        <div className="flex-1 space-y-4 py-1">
          <div className="h-4 bg-ink/10 rounded w-3/4"></div>
          <div className="space-y-2">
            <div className="h-4 bg-ink/10 rounded"></div>
            <div className="h-4 bg-ink/10 rounded w-5/6"></div>
          </div>
        </div>
      </div>
    </div>
  );

  if (properties.length === 0) return null;

  return (
    <section className="py-24 bg-parchment relative overflow-hidden">
      {/* Decorative Background Element */}
      <div className="absolute top-0 right-0 w-1/3 h-full bg-ink/[0.02] -z-10" />
      
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-baseline justify-between mb-16 gap-8">
          <div className="max-w-2xl">
            <span className="text-xs font-black uppercase tracking-[0.5em] text-terracotta mb-4 block">
              Catálogo de Asociados
            </span>
            <h2 className="text-5xl md:text-7xl font-display font-black uppercase text-ink leading-none mb-4 italic">
              Últimas <br /> 
              <span className="text-stroke-ink">Captaciones</span>
            </h2>
            <p className="text-xl font-serif italic text-ink/60">
              Una muestra de los activos gestionados a través de nuestro ecosistema por los mejores corredores de la región.
            </p>
          </div>
          
          <Link to="/propiedades">
            <Button variant="outline" className="group h-16 px-8 text-xs font-black uppercase tracking-widest border-2 border-ink hover:bg-ink hover:text-parchment transition-all">
              Ver Catálogo Completo <ArrowRight className="ml-4 h-4 w-4 group-hover:translate-x-2 transition-transform" />
            </Button>
          </Link>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-12">
          {properties.map((property) => (
            <PropertyCard
              key={property._id || property.id}
              {...property}
            />
          ))}
        </div>

        {/* B2B Call to Action for Properties */}
        <div className="mt-20 border-t-2 border-ink pt-12 flex flex-col md:flex-row items-center justify-between gap-8">
          <div className="flex items-center gap-6">
            <div className="bg-terracotta p-3 rotate-3">
              <Building2 className="h-6 w-6 text-parchment" />
            </div>
            <p className="text-sm font-serif italic text-ink/70 max-w-md">
              ¿Eres corredor? Publica tus propiedades aquí y accede a nuestra red de inversionistas y herramientas de gestión.
            </p>
          </div>
          <Link to="/signup">
            <Button variant="terracotta" className="h-12 px-10">UNIRSE COMO ASOCIADO</Button>
          </Link>
        </div>
      </div>
    </section>
  );
}
